export function parseBirthDate(birthDate) {
    if (!birthDate?.includes("-")) return {};

    const [birthYear, birthMonth, birthDay] = birthDate.split("-");
    return { birthYear, birthMonth, birthDay };
}

export function parseIdentificationNumber(id) {
    if (!id?.includes("-")) return {};

    const [idFirstHalf, idSecondHalf] = id.split("-");
    return { idFirstHalf, idSecondHalf };
}